import { sidebarMenuItemsService } from "@/services/api/sidebarMenuItemsService.js";

export function getMenuType(link) {
  const menuItem = sidebarMenuItemsService.find(item => item.link === link);
  return menuItem && menuItem.type ? menuItem.type : null;
}
